import Axios from "../../configs/axios.config";

 
// birthday card
export const downloadBirthdayCard = (id) => Axios.get(`/birthday/download/${id}`).then((res) => res.data.data);
export const downloadAllBirthdayCard = (data) => Axios.post(`/pdf/birthday`,data).then((res) => res.data.data);

// identity card
export const downloadIdentityCard = (data) => Axios.get(`/pdf/icard-multiple`,{params:data}).then((res) => res.data.data);
